// extracted by mini-css-extract-plugin
export var borderRadius = "_6h-4";
export var large = "_6h-3";
export var logoContainer = "_6h-0";
export var nameLogo = "_6h-2";
export var small = "_6h-1";